module.exports = __webpack_public_path__ + "img/EducationProgramKenya_1.9b6676eb.jpg";